"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createQueryParameters;

var _computePageLimit = _interopRequireDefault(require("./computePageLimit"));

var _computePageOffset = _interopRequireDefault(require("./computePageOffset"));

var _formatSortDescriptors = _interopRequireDefault(require("./formatSortDescriptors"));

var _normalizeParameters2 = _interopRequireDefault(require("./normalizeParameters"));

function createQueryParameters() {
  var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _normalizeParameters = (0, _normalizeParameters2.default)(parameters),
      entriesPerPage = _normalizeParameters.entriesPerPage,
      filterBy = _normalizeParameters.filterBy,
      pageNumber = _normalizeParameters.pageNumber,
      sortBy = _normalizeParameters.sortBy;

  var query = {};

  if (entriesPerPage != null && pageNumber != null) {
    query.limit = (0, _computePageLimit.default)(entriesPerPage);
    query.offset = (0, _computePageOffset.default)(pageNumber, entriesPerPage);
  }

  if (filterBy != null) {
    query.q = filterBy.join(' ');
  }

  if (sortBy != null) {
    query.sort = (0, _formatSortDescriptors.default)(sortBy);
  }

  return query;
}